<template>
  <v-form v-model="valid" ref="form" v-bind="this.$attrs">
    <!-- Thông tin bố -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          ref="dadName"
          v-model="dadName"
          label="Họ và tên bố"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="dadJob" label="Nghề nghiệp" hide-details="auto" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="dadCompany" label="Cơ quan công tác" hide-details="auto" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          ref="dadPhone"
          v-model="dadPhone"
          label="Số điện thoại bố"
          hide-details="auto"
          outlined
          dense
          :rules="[$rules.phone]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          ref="dadEmail"
          v-model="dadEmail"
          label="Email bố"
          hide-details="auto"
          dense
          outlined
          :rules="[$rules.email]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="my-6" />
    <!-- Thông tin mẹ -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          ref="momName"
          v-model="momName"
          label="Họ và tên mẹ"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="momJob" label="Nghề nghiệp" hide-details="auto" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="momCompany" label="Cơ quan công tác" hide-details="auto" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="momPhone"
          label="Số điện thoại mẹ"
          hide-details="auto"
          outlined
          dense
          :rules="[$rules.phone]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="momEmail"
          label="Email mẹ"
          hide-details="auto"
          outlined
          dense
          :rules="[$rules.email]"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import get from 'lodash-es/get'
export default {
  props: {
    student: {
      type: [Object],
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    dadName: '',
    dadJob: '',
    dadCompany: '',
    dadPhone: '',
    dadEmail: '',

    momName: '',
    momJob: '',
    momCompany: '',
    momPhone: '',
    momEmail: '',
    rules: {
      required: value => !!value || 'Required.',
      min: v => v.length >= 6 || 'Min 8 characters',
      email: v => /.+@.+/.test(v) || 'E-mail must be valid'
    }
  }),
  created() {
    if (this.student) {
      this.dadName = get(this.student, 'data.dadName')
      this.dadJob = get(this.student, 'data.dadJob')
      this.dadCompany = get(this.student, 'data.dadCompany')
      this.dadPhone = get(this.student, 'data.dadPhone')
      this.dadEmail = get(this.student, 'data.dadEmail')

      this.momName = get(this.student, 'data.momName')
      this.momJob = get(this.student, 'data.momJob')
      this.momCompany = get(this.student, 'data.momCompany')
      this.momPhone = get(this.student, 'data.momPhone')
      this.momEmail = get(this.student, 'data.momEmail')
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    getData() {
      return {
        dadName: this.dadName,
        dadJob: this.dadJob,
        dadCompany: this.dadCompany,
        dadPhone: this.dadPhone,
        dadEmail: this.dadEmail,

        momName: this.momName,
        momJob: this.momJob,
        momCompany: this.momCompany,
        momPhone: this.momPhone,
        momEmail: this.momEmail
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  }
}
</script>

<style scoped></style>
